
import i18n from '../language.js';

class AbsenceSettings{
  constructor(){
   
  }
/*
  getReasons(){
    return [
      {value:"flu",name:i18n.t('language.flu')},
      {value:"a_cold",name:i18n.t('language.a_cold')},
      {value:"stomach_ache",name:i18n.t('language.stomach_ache')},
      {value:"other",name:i18n.t('language.other')},
    ]
  }
*/
  getDurationText(duration){
    
    
    var pretext = i18n.t('language.duration')+": ";

    if(duration=="0.5"){
      return pretext+i18n.t('language.half_day');
    }
    if(duration==0){
      return pretext+i18n.t('language.unknown')
    }
    if(String(duration)==="1.0"){
      return pretext+"1 "+i18n.t('language.day');
    }
    
    return pretext+parseInt(duration)+" "+i18n.t('language.days');
    
  }

  getDurations(){
    return [
      {value:"0.5",name:i18n.t('language.half_day')},
      {value:"1.0",name:"1 "+i18n.t('language.day')},
      {value:"2.0",name:"2 "+i18n.t('language.days')},
      {value:"3.0",name:"3 "+i18n.t('language.days')},
      {value:"4.0",name:"4 "+i18n.t('language.days')},
      {value:"5.0",name:"5 "+i18n.t('language.days')},
      {value:"6.0",name:"6 "+i18n.t('language.days')},
      {value:"7.0",name:"7 "+i18n.t('language.days')},
      {value:"8.0",name:"8 "+i18n.t('language.days')},
      {value:"9.0",name:"9 "+i18n.t('language.days')},
      {value:"10.0",name:"10 "+i18n.t('language.days')},
      {value:"0.0",name:i18n.t('language.unknown')},
      ]
  }
}

export let absenceSettings = new AbsenceSettings();